var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("News Feed")]),_vm._l((_vm.posts),function(item){return [_c('post-view',{attrs:{"item":item,"users":_vm.optionUserItemsById}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }